import React from 'react';
import { NavLink } from 'react-router-dom';
const Uganda1_mature_entry_subjects = () => {
  return (
    <div className='fixed top-16 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-cyan-400 items-center z-50 justify-evenly'>
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_mature_entry/uganda1_mature_entry_eng" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >English Language</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_mature_entry/uganda1_mature_entry_math" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Mathematics</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_mature_entry/uganda1_mature_entry_apt" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Aptitude Test/Specialized Paper</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_mature_entry/uganda1_mature_entry_gen" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >General Paper</NavLink>        
        
    </div>
  );
}

export default Uganda1_mature_entry_subjects;
